import { Component, OnInit } from '@angular/core';
import {NotificationMsg} from "../../common/model/notificationMsg.model";
import {NotificationsService} from "../../common/service/notifications.service";

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

  //_notifications: NotificationMsg[] = <NotificationMsg[]>[{type:"alert", title:"no alert"}];
    _notifications: NotificationMsg[] = [];
  sub = {};

  constructor( private notify: NotificationsService) {
      notify.emitter.subscribe(x=> this.sub = x );
      notify.notifications$.asObservable().subscribe(x=>this._notifications = x);
  }

  ngOnInit() {
  }

}
